import { render } from "./app-footer.vue?vue&type=template&id=844ab4b6"
import script from "./app-footer.vue?vue&type=script&lang=js"
export * from "./app-footer.vue?vue&type=script&lang=js"

import "./app-footer.vue?vue&type=style&index=0&id=844ab4b6&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__